import { request } from 'api/request';

export interface MCPServer {
  id: number;
  clientId: string;
  label: string;
  description?: string;
  clientSecret: string;
  serverUrl: string;
}

export interface MCPServerJourneyCreate {
  id?: number;
  server: string;
  journey: string;
  attributes: {
    attributeShortId: string;
    description: string;
    isShown?: boolean;
    isRequired?: boolean;
  }[];
}

export interface MCPServerJourney {
  id?: number;
  server: string;
  journey: string;
  journeyTitle: string;
  journeyDescription: string;
  description?: string;
  attributes: {
    attributeShortId: string;
    description: string;
    title?: string;
    attributeType?: string;
    journeyIsRequired?: boolean;
    isCustomized?: boolean;
    isShown?: boolean;
    isRequired?: boolean;
  }[];
}

export interface SlackSettings {
  id: number;
  teamId: string;
  mcpServer?: number | null;
}

export const createMCPServer = async (data: { label: string; description?: string }) => {
  const response = await request.post<MCPServer>('/v1/mcp/servers/', data);
  return response.data;
};

export const getMCPServers = async () => {
  const response = await request.get<MCPServer[]>('/v1/mcp/servers/');
  return response.data;
};

export const createMCPServerJourney = async (data: MCPServerJourneyCreate) => {
  const response = await request.post<MCPServerJourney>(
    `/v1/mcp/servers/${data.server}/journeys/`,
    data
  );
  return response.data;
};

export const updateMCPServerJourney = async (data: MCPServerJourneyCreate) => {
  const response = await request.patch<MCPServerJourney>(
    `/v1/mcp/servers/${data.server}/journeys/${data.id}/`,
    data
  );
  return response.data;
};

export const deleteMCPServerJourney = async (serverId: string, id: number) => {
  const response = await request.delete(`/v1/mcp/servers/${serverId}/journeys/${id}/`);
  return response.data;
};

export const getMCPServerJourneys = async (serverId: string) => {
  const response = await request.get<MCPServerJourney[]>(`/v1/mcp/servers/${serverId}/journeys/`);
  return response.data;
};

export const deleteMCPServer = async (clientId: string) => {
  const response = await request.delete(`/v1/mcp/servers/${clientId}/`);
  return response.data;
};

export const updateMCPServer = async (data: {
  clientId: string;
  label: string;
  description?: string;
}) => {
  const response = await request.patch<MCPServer>(`/v1/mcp/servers/${data.clientId}/`, {
    label: data.label,
    description: data.description,
  });
  return response.data;
};

export const getSlackSettings = async (): Promise<SlackSettings[]> => {
  const response = await request.get('/v1/mcp/slack-settings/');
  return response.data;
};

export const createSlackSettings = async (data: {
  teamId: string;
  token: string;
  mcpServer?: number | null;
}): Promise<SlackSettings> => {
  const response = await request.post('/v1/mcp/slack-settings/', data);
  return response.data;
};

export const updateSlackSettings = async (data: {
  id: number;
  teamId: string;
  token: string;
  mcpServer?: number | null;
}): Promise<SlackSettings> => {
  const response = await request.put(`/v1/mcp/slack-settings/${data.id}/`, data);
  return response.data;
};
